import React from 'react';
import FontAwesome from 'react-fontawesome';
import styles from './Notification.css';

class Notification extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="col-md-4 col-sm-12">
      {this.props.message ?
        <div className="toast">
            <div className={this.props.success ? 'toast-body text-light bg-success' : 'toast-body text-light bg-danger'}>
              {this.props.message}
            </div>
          </div>
        : null}
      </div>
    );
  }
}

export default Notification;